export const PLANNING_COCKPIT_TOUR_NAMESPACE = 'jbp-planning-cockpit-tour'

// i18n key registry for the Planning Cockpit widget tour. Step keys are named after what the
// step shows rather than its position, so reordering the tour does not orphan them.
export const PLANNING_COCKPIT_TOUR_TRANSLATION_KEYS = {
  tourButton: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-tour-button`,
  steps: {
    welcome: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-welcome-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-welcome-description`,
    },
    partnerDetails: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-partner-details-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-partner-details-description`,
    },
    salesTeam: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-sales-team-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-sales-team-description`,
    },
    scopePanel: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-panel-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-panel-description`,
    },
    revenueTile: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-revenue-tile-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-revenue-tile-description`,
    },
    initiativesTile: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-tile-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-tile-description`,
    },
    attentionTile: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-attention-tile-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-attention-tile-description`,
    },
    documentsTile: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-documents-tile-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-documents-tile-description`,
    },
    overviewFork: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-overview-fork-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-overview-fork-description`,
      next: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-overview-fork-next`,
      dismiss: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-overview-fork-dismiss`,
    },
    scopeBar: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-bar-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-bar-description`,
    },
    scopeFiscalYear: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-fiscal-year-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-fiscal-year-description`,
    },
    statusCompleteness: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-status-completeness-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-status-completeness-description`,
    },
    statusAcknowledgment: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-status-acknowledgment-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-status-acknowledgment-description`,
    },
    statusPlanQuality: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-status-plan-quality-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-status-plan-quality-description`,
    },
    scopePeriod: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-period-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-period-description`,
    },
    scopeMetric: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-metric-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-metric-description`,
    },
    scopeCurrency: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-currency-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-scope-currency-description`,
    },
    trainingCentre: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-training-centre-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-training-centre-description`,
    },
    programmeTabs: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-programme-tabs-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-programme-tabs-description`,
    },
    categoryChip: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-category-chip-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-category-chip-description`,
    },
    revenueDetail: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-revenue-detail-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-revenue-detail-description`,
    },
    revenueQuality: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-revenue-quality-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-revenue-quality-description`,
    },
    initiativesList: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-list-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-list-description`,
    },
    initiativesMdf: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-mdf-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-mdf-description`,
    },
    initiativesQuality: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-quality-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-initiatives-quality-description`,
    },
    documentsDetail: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-documents-detail-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-documents-detail-description`,
    },
    finish: {
      title: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-finish-title`,
      description: `${PLANNING_COCKPIT_TOUR_NAMESPACE}-finish-description`,
    },
  },
}
